import { COUNTRIES, LOCALIZATION } from './constants'

export const FormattedCurrency = (num) =>
  new Intl.NumberFormat(COUNTRIES[LOCALIZATION]?.numberFormat, {
    style: 'currency',
    currency: COUNTRIES[LOCALIZATION]?.currency || 'USD',
  }).format(num)
